import { Action } from '@ngrx/store';
import { ErrorResponse, QueryOptions } from '~shared/models';
import { SearchResponse } from '../../models';

export enum ProductsActionTypes {
  LOAD_PRODUCTS = '[Catalog] Products Load',
  RESET_PRODUCTS = '[Catalog] Products Reset',
  LOAD_PRODUCTS_SUCCESS = '[Catalog] Products Load Success',
  LOAD_PRODUCTS_FAILURE = '[Catalog] Products Load Failure'
}

export class LoadProducts implements Action {
  readonly type = ProductsActionTypes.LOAD_PRODUCTS;

  constructor(public payload: {queryOptions: QueryOptions}) {
  }
}

export class ResetProducts implements Action {
  readonly type = ProductsActionTypes.RESET_PRODUCTS;

  constructor() {
  }
}

export class LoadProductsSuccess implements Action {
  readonly type = ProductsActionTypes.LOAD_PRODUCTS_SUCCESS;

  constructor(public payload: { response: SearchResponse, queryOptions: QueryOptions } ) {
  }
}

export class LoadProductsFailure implements Action {
  readonly type = ProductsActionTypes.LOAD_PRODUCTS_FAILURE;

  constructor(public payload: {error: ErrorResponse}) {
  }
}

export type ProductsActionsUnion = LoadProducts
| ResetProducts
| LoadProductsSuccess
| LoadProductsFailure;
